import React from "react";
import SmartIcon from "../SmartIcon.tsx";
import {GoChevronRight} from "react-icons/go";
import {titleCase} from "../../utils/utils.ts";
import {SeriesCharacterInfo} from "../../models/interfaces/series.interface.ts";

interface SeriesCharacterProps {
  character: SeriesCharacterInfo;
  onClick: (characterId: string) => void;
  isOpen: boolean;
  onDelete: (characterId: string) => void;
}

const SeriesCharacterBasicDetails: React.FC<SeriesCharacterProps> = (
  {
    character,
    onClick,
    isOpen,
    onDelete,
  }: SeriesCharacterProps) => {

  const onDeleteCharacterClicked = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    e.stopPropagation();
    onDelete(character.characterId);
  }

  return (
    <div
      className="flex w-full items-center justify-between gap-4 p-4 rounded-xl hover:bg-n-600 cursor-pointer"
      onClick={() => onClick(character.characterId)}
    >
      <div className="flex items-center gap-2">
        <SmartIcon
          name={GoChevronRight}
          className={`w-4 h-4 transition-transform duration-200 ${
            isOpen ? "rotate-90 fill-n-200" : "rotate-0 fill-n-400"
          }`}
        />
        <span className="text-md">{titleCase(character.name)}</span>
        <div className="text-xs text-n-400 ml-2">({titleCase(character.gender ?? "")})</div>
      </div>
      <div className="cursor-pointer" onClick={onDeleteCharacterClicked}>
        <SmartIcon name="trash" className="w-5 h-5 fill-bloodCrimson-400/80 hover:fill-bloodCrimson-400"/>
      </div>
    </div>
  )
}

export default SeriesCharacterBasicDetails;